import React from 'react';
import { injectIntl } from 'react-intl';
import { object } from 'prop-types';
import Icon from '../Icon/Icon';
import { formatToCurrency, currencyToSign, createMarkup } from '../../utils/utils';
import { iFMessage } from '../../hoc/IntlComponents';

const propTypes = {
  rules: object.isRequired,
};

const walletsType = [22, 23, 40];

const getFormattedMaxPayments = ({
  maxPaymentDay,
  maxPayment,
  maxPaymentMonth,
  purseType,
  chunksAllowed,
  currencySign,
}) => {
  return {
    maxDay:
      maxPaymentDay !== null
        ? `${formatToCurrency(maxPaymentDay, '0,0')}${currencySign}`
        : maxPaymentDay,
    maxMonth:
      maxPaymentMonth !== null
        ? `${formatToCurrency(maxPaymentMonth, '0,0')}${currencySign}`
        : maxPaymentMonth,
    maxPaymentOne:
      !chunksAllowed && maxPayment !== null && !walletsType.includes(purseType)
        ? `${formatToCurrency(maxPayment, '0,0')}${currencySign}`
        : purseType && walletsType.includes(purseType)
        ? `${formatToCurrency(300000, '0,0')}${currencySign}`
        : maxPayment,
  };
};

const getRules = (rules, currencySign, intl, purseId) => {
  const {
    commission = 0,
    commissionText = null,
    minPayment = 1,
    maxPayment = null,
    maxPaymentDay = null,
    maxPaymentMonth = null,
    chunksAllowed = true,
  } = rules;
  const purse =
    rules.wallets && rules.wallets.length ? rules.wallets.find((w) => w.id === purseId) : null;
  // let template = '<span class="payment-rules">';

  // template += 'Min payment amount: {minPayment}; ';
  // template += 'Max payment per day: {maxPaymentDay}; ';
  // template += '{maxPayment} ';
  // template += '{commission}';
  // template += '</span>';

  let commissionValue = '';
  let commissionSign = '';
  if (purse && purse.bonus) {
    commissionValue = purse.bonus;
    commissionSign = purse.bonus[0];
  } else if (commissionText) {
    commissionSign = commissionText[0];
    commissionValue = commissionText;
  } else {
    commissionSign = commission[0];
    commissionValue = commission;
  }

  switch (commissionSign) {
    case '+':
      commissionValue = iFMessage({ intl, id: 'payments.rules-info.bonus' }) + commissionValue;
      break;
    case '-':
      commissionValue = iFMessage({ intl, id: 'payments.rules-info.commission' }) + commissionValue;
      break;
    default:
      commissionValue = iFMessage({ intl, id: 'payments.rules-info.no-commission' });
      break;
  }

  const { maxDay, maxPaymentOne, maxMonth } = getFormattedMaxPayments({
    maxPaymentDay,
    maxPayment,
    maxPaymentMonth,
    chunksAllowed,
    currencySign,
    purseType: purse?.type,
  });

  let maxPaymentPay = '';
  if (maxDay || maxMonth || maxPaymentOne) {
    let oneCard = '';
    let day = '';
    let payment = '';
    let month = '';
    let delimiter = '';

    if (
      purse?.type === 3 || // банк. карты RU
      purse?.type === 30 || // банк. карты UA
      purse?.type === 37 || // банк. карты KZ
      purse?.type === 4 || // ЮMoney
      purse?.type === 5 // QIWI
    ) {
      oneCard = intl.formatMessage({
        id: 'payments.rules-info.one-card',
        defaultMessage: 'On one card ',
      });
    }
    if (maxDay) {
      day = intl.formatMessage(
        {
          id: 'payments.rules-info.per-day',
          defaultMessage: 'no more than {value} per day',
        },
        { value: maxDay },
      );
    }
    if (maxPaymentOne && maxPaymentOne != 0 && !chunksAllowed) {
      let idMessage = 'payments.rules-info.per-one';
      if (purse?.type === 15) {
        idMessage = 'payments.rules-info.per-one-15';
      }

      payment = intl.formatMessage(
        {
          id: idMessage,
          defaultMessage: 'no more than {value} at a time',
        },
        {
          value: maxPaymentOne,
        },
      );
    }
    if (purse?.type && walletsType.includes(purse?.type)) {
      payment = intl.formatMessage(
        {
          id: 'payments.rules-info.per-one',
          defaultMessage: 'no more than {value} at a time',
        },
        { value: maxPaymentOne },
      );
    }

    if (maxMonth) {
      month = intl.formatMessage(
        {
          id: 'payments.rules-info.per-month',
          defaultMessage: 'no more than {value} per month',
        },
        { value: maxMonth },
      );
    }
    if (maxPaymentDay && maxPaymentMonth) {
      delimiter = '; ';
    }
    if (maxPaymentDay && maxPaymentOne) {
      delimiter = '; ';
    }

    // maxPaymentPay = payment ? ` (${oneCard}${day}${delimiter}${payment});` : ` (${oneCard}${day}${delimiter}${month});`;
    maxPaymentPay = payment
      ? ` (${oneCard}${day}${delimiter}${payment});`
      : payment == '' && month
      ? ` (${oneCard}${day}${delimiter}${month});`
      : '';
  }

  return (
    // Минимальная выплата: {minPayment}; {maxPaymentPay} {commissionValue}
    <span className="payment-rules">
      {`${iFMessage({ intl, id: 'payments.rules-info.message' })}: ${formatToCurrency(
        minPayment,
        '0,0',
      )}${currencySign}; ${maxPaymentPay}`}
    </span>
  );
};

const PaymentRules = ({
  rules,
  className,
  currency,
  intl,
  theme,
  purseId,
  wallets,
  messageAlert,
}) => {
  const getSelectedWallet = () => {
    let result;
    wallets.map((wallet) => {
      let find = wallet.wallets.find((wallet) => wallet.id === purseId);
      if (find) return (result = find);
    });
    return result;
  };

  const replaceMD = (message) => {
    return (
      <span
        className="payment-rules"
        dangerouslySetInnerHTML={createMarkup(
          message.replace(
            /(?:\[(.*)\])(?:\(([^\(]*)\))/g,
            '<a class="link" href="$2" target="_blank">$1</a>',
          ),
        )}
      />
    );
  };

  if (messageAlert) {
    const msg = replaceMD(messageAlert);

    return (
      <span
        className={theme !== 4 ? 'payment-rules-wrapper gray' : 'payment-rules-wrapper dark-gray'}
      >
        <Icon className={className} type="info" />
        {msg}
      </span>
    );
  }

  const getCurrencyValue = () => {
    if (!currency) {
      return '';
    }
    if (typeof currency === 'string' && purseId) {
      const { convert_from, currency: convertToCurrency } = getSelectedWallet();
      return convert_from
        ? `\u00A0${currencyToSign(
            convert_from.indexOf(currency) > -1 ? convertToCurrency : currency,
          )}`
        : `\u00A0${currencyToSign(currency)}`;
    }
    if (typeof currency === 'object' && currency.value) {
      return `\u00A0${currencyToSign(currency.value)}`;
    }
    return '';
  };
  const currencySign = getCurrencyValue();

  return (
    <span
      className={theme !== 4 ? 'payment-rules-wrapper gray' : 'payment-rules-wrapper dark-gray'}
    >
      <Icon className={className} type="info" />
      {getRules(rules, currencySign, intl, purseId)}
    </span>
  );
};

PaymentRules.propTypes = propTypes;

export default injectIntl(PaymentRules);
